
import { ButtonFieldConfig, DynamicFormArray, FormFieldConfig } from './form.model';
import { SpinIdNumber, DealerNumber, NameText, defaultSearchContainerButtons, expirationDate, testTakenDate, AreaMutipleSelect, DistrictMutipleSelect, BrandDropdown } from './form-fields.model';
import { DataTableSchema, DefaultTableSchema, TableColumnSchema } from './dynamic-data-table.model';
import { FETCH_METHODS, SearchConfig } from './api.model';

const FormFieldArray: FormFieldConfig[] = structuredClone([
  SpinIdNumber, DealerNumber, NameText, { ...structuredClone(BrandDropdown), showSelect: false, multiple:true,defaultValue:[ 'LEXUS' ,'TOYOTA']}, AreaMutipleSelect,
  { ...structuredClone(DistrictMutipleSelect), options: [{ fieldLabel: '01', fieldValue: '01' }, { fieldLabel: '02', fieldValue: '02' }, { fieldLabel: '03', fieldValue: '03' }, { fieldLabel: '04', fieldValue: '04' }, { fieldLabel: '05', fieldValue: '05' }, { fieldLabel: '06', fieldValue: '06' }] },
  testTakenDate, expirationDate]);

const FormButtonArray: ButtonFieldConfig[] = structuredClone(defaultSearchContainerButtons);

export const AseLexusCertificationStatusSearchConfig: SearchConfig = {
  method: FETCH_METHODS['Post'],
  path: 'aseCertificationStatus',
  body: {
    "spinId": "",
    "dealerNumber": "",
    "fullName": "",
    "ase": "",
    "testTakenDate": "",
    "expirationDate": "",
    "district": [],
    "area": []
  }
}

export const AseCertExportSearchConfig: SearchConfig = {
  method: FETCH_METHODS['Post'],
  path: 'getSignedUrl',
  body: {
    bucketName: '',
    key: '',
    type: 'Download'
  }
}

export const AseCerStatusTitle = "ASE Certification Status";

export const AseCerStatusFormArray: DynamicFormArray = {
  FieldsArray: FormFieldArray,
  ButtonsArray: FormButtonArray,
  searchConfig: AseLexusCertificationStatusSearchConfig,
  autoSearchOnLoad: true
}

const AseCerStatusColumnSchema: Array<TableColumnSchema> = [
  { label: 'SPIN ID', fieldKey: 'spinId', sticky: true },
  { label: 'DEALER', fieldKey: 'dealerCode', sticky: true },
  { label: 'NAME', fieldKey: 'fullName' },
  { label: 'COURSE', fieldKey: 'testId' },
  { label: 'ASE CERTIFICATION STATUS', fieldKey: 'certExpStatus', isNotCamelCase: true },
  { label: 'EXPIRATION DATE', fieldKey: 'expirationDate' },
  { label: 'INITIAL TEST TAKEN DATE', fieldKey: 'testTakenDate' },
  { label: 'Area/Region', fieldKey: 'area' },
  { label: 'District', fieldKey: 'district' }
]

export const AseCerStatusTableSchema: DataTableSchema = {
  ...structuredClone(DefaultTableSchema),
  columnSchema: AseCerStatusColumnSchema,
  searchInfo: {
    placeholder: 'Filter',
    filtarableSpecificFields: []
  },
  serverSidePaginatation: true,
  exportConfig: {
    fileName: 'Ase-lexus-certification-status',
    isCamelCase: ['fullName', 'area'],
    exportMessage: "ASE Cetification Status Data"
  },

}
